/*** IMPORTS FROM imports-loader ***/
var define = false;

import map from 'lodash/map'
import $ from 'jquery'
import 'slick-carousel'
import PhotoSwipe from 'photoswipe'

// eslint-disable-next-line import/prefer-default-export
export function initializeProductDetail($container) {
  //
  // Photos
  //

  const $bigSlides = $container.find('.big-slides')
  const $thumbSlides = $container.find('.thumb-slides')

  if ($bigSlides.length) {
    const opts = {
      infinite: true,
      lazyLoad: 'progressive',
      adaptiveHeight: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('#slider-prev').html(),
      nextArrow: $('#slider-next').html(),
      rows: 0,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
          },
        },
      ],
    }

    if ($thumbSlides.length) {
      opts.asNavFor = '.thumb-slides'
    }

    $bigSlides.slick(opts)

    //
    // PhotoSwipe
    //

    $bigSlides.on('click', '.slide', (ev) => {
      ev.preventDefault()
      const gallery = new PhotoSwipe({
        index: $(ev.currentTarget).closest('.slick-slide').data('slick-index'),
        bgOpacity: 1,
        dataSource: map($container.data('photos'), (photo) => ({
          src: window.APP.context.site.files_url + photo.path,
          w: photo.width,
          h: photo.height,
        })),
      })
      gallery.init()
    })
  }

  if ($thumbSlides.length) {
    $thumbSlides.slick({
      asNavFor: '.big-slides',
      focusOnSelect: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: $('#slider-prev').html(),
      nextArrow: $('#slider-next').html(),
      centerMode: true,
      centerPadding: '60px',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
          },
        },
      ],
    })

    $thumbSlides.on('click', '.slide', (ev) => {
      $thumbSlides.slick('slickGoTo', $(ev.currentTarget)
        .closest('.slick-slide')
        .data('slick-index'))
    })
  }
}

